import React from "react";
import { Clock, Sparkles, ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import { useS } from "../../lib/simple";

export function StarterResult({ action, time, onStart, onEdit }) {
  const { s } = useS();
  return (
    <div data-testid="starter-result">
      <p className="inline-flex items-center gap-2 text-xs font-bold tracking-wide text-neon uppercase"><Sparkles size={15} /> {s("first_action")}</p>
      <h1 className="font-display font-black text-2xl sm:text-3xl leading-tight mt-3" data-testid="starter-action-title">{action.title}</h1>
      <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-white/5 border border-white/10 px-3.5 py-2 text-sm" data-testid="starter-action-time">
        <Clock size={15} className="text-neon" /> {s("est_time", { m: action.minutes })}
      </div>
      {time && <p className="text-xs text-[hsl(var(--muted-foreground))] mt-2">{s("fits_time", { t: s(`time_${time}`).toLowerCase() })}</p>}
      <Button onClick={onStart} data-testid="starter-action-cta"
        className="w-full mt-8 rounded-full h-14 bg-gradient-to-r from-primary to-neon text-white lb-glow-btn font-semibold text-base">
        {action.cta} <ArrowRight size={18} className="ml-1.5" />
      </Button>
      <button onClick={onEdit} data-testid="starter-edit-answers" className="w-full mt-3 min-h-[44px] text-sm text-[hsl(var(--muted-foreground))] hover:text-white transition-colors">
        {s("edit_answers")}
      </button>
    </div>
  );
}
